import { FontCategories } from '@enums/font';
import { Font } from '@typings/font';

/**
 * Taken from TinyMCE source code:
 * https://github.com/tinymce/tinymce/blob/e58a4df48b48d9a713081ab5587f37344294563b/modules/tinymce/src/themes/silver/main/ts/api/Options.ts#L97
 */
export const FONT_FAMILY_FORMATS: Font[] = [
  {
    category: FontCategories.Monospace,
    family: 'Andale Mono'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Arial'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Arial Black'
  },
  {
    category: FontCategories.Serif,
    family: 'Book Antiqua'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Circular-Book'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Comic Sans MS'
  },
  {
    category: FontCategories.Monospace,
    family: 'Courier New'
  },
  {
    category: FontCategories.Serif,
    family: 'Georgia'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Helvetica'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Impact'
  },
  {
    family: 'Symbol'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Tahoma'
  },
  {
    category: FontCategories.Monospace,
    family: 'Terminal'
  },
  {
    category: FontCategories.Serif,
    family: 'Times New Roman'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Trebuchet MS'
  },
  {
    category: FontCategories.SansSerif,
    family: 'Verdana'
  },
  {
    family: 'Webdings'
  },
  {
    family: 'Wingdings'
  }
];
